export default __webpack_public_path__ + "static/media/displayTinder.c34686e3.png";